import { render, staticRenderFns } from "./voteProgress.vue?vue&type=template&id=62bbbb06&scoped=true"
import script from "./voteProgress.vue?vue&type=script&lang=js"
export * from "./voteProgress.vue?vue&type=script&lang=js"
import style0 from "./voteProgress.vue?vue&type=style&index=0&id=62bbbb06&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bbbb06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62bbbb06')) {
      api.createRecord('62bbbb06', component.options)
    } else {
      api.reload('62bbbb06', component.options)
    }
    module.hot.accept("./voteProgress.vue?vue&type=template&id=62bbbb06&scoped=true", function () {
      api.rerender('62bbbb06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/governance/components/voteProgress.vue"
export default component.exports